(function ($) {
    /* Document ready functions */
    $(document).ready(function () {
        setTimeout(function () {
            $('.store-container').each(function () {
                $(this).find('.equal').equalHeights();
            });
        }, 100);
    });

    /* Resize functions */
    $(window).resize(function () {
        setTimeout(function () {
            $('.store-container').each(function () {
                $(this).find('.equal').height('auto');
                $(this).find('.equal').equalHeights();
            });
        }, 100);
    });
})(jQuery);
